(function () {
	'use strict';

	angular
		.module('wizard-future7.directives')
		.directive('footer', Footer)

	/** @ngInject */
	function Footer(PATHS) {
		function FooterController($scope, $rootScope) {
			const vm = this;

			$scope.$watch(
				() => $rootScope.$root.currentState,
				value => vm.hide = value == 'default.countdown' || value == 'default.ebook' || value == 'default.not-found' ? true : false
			);

			init();

			function init() {

			}

		}

		return {
			bindToController: true,
			controller: FooterController,
			controllerAs: 'vm',
			restrict: 'AE',
			templateUrl: `${PATHS.PHYSICAL}/directives/footer/footer.html`,
			scope: {}
		}
	}
}());